<template>
  <manual-page
    title="Modulo de Contabilidad"
    description="Registra y controla los ingresos y egresos de tu sucursal."
    :show-video="true"
    :related-links="relatedLinks"
    :action-route="{ name: 'accounting' }"
    action-text="Ir a Contabilidad"
  >
    <h2>Vista General</h2>
    <p>El modulo de contabilidad te permite:</p>
    <ul>
      <li><strong>Registrar ingresos:</strong> Ventas y cobros</li>
      <li><strong>Registrar egresos:</strong> Gastos y pagos</li>
      <li><strong>Consultar balance:</strong> Estado financiero actual</li>
      <li><strong>Generar reportes:</strong> Analisis de ingresos y gastos</li>
    </ul>

    <div class="tip-box">
      <p><strong>Tip:</strong> Manten tus registros al dia para un control financiero preciso.</p>
    </div>

    <h2>Ingresos (Ventas)</h2>
    <p>La seccion de ingresos muestra:</p>
    <ul>
      <li>Lista de todos los ingresos registrados</li>
      <li>Fecha de cada transaccion</li>
      <li>Monto y concepto</li>
      <li>Metodo de pago utilizado</li>
      <li>Total de ingresos del periodo</li>
    </ul>

    <div class="info-box">
      <p><strong>Nota:</strong> Los pagos de ordenes se registran automaticamente como ingresos.</p>
    </div>

    <h2>Egresos (Gastos)</h2>
    <p>La seccion de egresos muestra:</p>
    <ul>
      <li>Lista de todos los gastos registrados</li>
      <li>Fecha de cada pago</li>
      <li>Monto y categoria</li>
      <li>Proveedor o beneficiario</li>
      <li>Total de egresos del periodo</li>
    </ul>

    <div class="tip-box">
      <p><strong>Tip:</strong> Registra todos los gastos para tener un control completo.</p>
    </div>

    <h2>Registro de Movimientos</h2>

    <h3>Registrar Ingreso</h3>
    <p>Para registrar un ingreso:</p>

    <div class="step-card">
      <span class="step-number">1</span>
      Ve a <strong>Contabilidad > Ingresos</strong>
    </div>

    <div class="step-card">
      <span class="step-number">2</span>
      Haz clic en "Registrar"
    </div>

    <div class="step-card">
      <span class="step-number">3</span>
      Completa los datos:
      <ul>
        <li>Fecha del ingreso</li>
        <li>Monto</li>
        <li>Concepto o descripcion</li>
        <li>Metodo de pago</li>
        <li>Cliente (si aplica)</li>
      </ul>
    </div>

    <div class="step-card">
      <span class="step-number">4</span>
      Guarda el registro
    </div>

    <h3>Registrar Egreso</h3>
    <p>Para registrar un egreso:</p>

    <div class="step-card">
      <span class="step-number">1</span>
      Ve a <strong>Contabilidad > Egresos</strong>
    </div>

    <div class="step-card">
      <span class="step-number">2</span>
      Haz clic en "Crear"
    </div>

    <div class="step-card">
      <span class="step-number">3</span>
      Completa los datos:
      <ul>
        <li>Fecha del gasto</li>
        <li>Monto</li>
        <li>Categoria (nomina, insumos, servicios, etc.)</li>
        <li>Descripcion</li>
        <li>Proveedor o beneficiario</li>
      </ul>
    </div>

    <div class="step-card">
      <span class="step-number">4</span>
      Guarda el registro
    </div>

    <h2>Categorias</h2>

    <h3>Categorias de Ingresos</h3>
    <p>Categorias comunes de ingresos:</p>
    <ul>
      <li>Ventas de planes (suscripciones)</li>
      <li>Ventas de productos adicionales</li>
      <li>Otros ingresos</li>
    </ul>

    <h3>Categorias de Egresos</h3>
    <p>Categorias comunes de egresos:</p>
    <ul>
      <li>Compra de insumos</li>
      <li>Nomina / Salarios</li>
      <li>Servicios (luz, agua, internet)</li>
      <li>Renta del local</li>
      <li>Otros gastos operativos</li>
    </ul>

    <div class="tip-box">
      <p><strong>Tip:</strong> Usa categorias consistentes para mejores reportes.</p>
    </div>
  </manual-page>
</template>

<script>
import ManualPage from "@/components/manual/ManualPage.vue";

export default {
  name: "ManualAccounting",
  components: { ManualPage },
  data() {
    return {
      relatedLinks: [
        { route: "manualReports", label: "Reportes" },
        { route: "manualOrders", label: "Ordenes" },
        { route: "manualGettingStarted", label: "Primeros Pasos" },
      ],
    };
  },
};
</script>
